// let url = 'http://192.168.2.191:3090'
// let url = '192.168.2.187:3090'
let url = 'www.moodsmap.com'
// let url = '192.168.2.187:3090'

let ipConfig = {
  getTypHoonData: `https://${url}/SWDataservice/interface/v1/api?interfaceId=getTypHoonData`,
  getTyphoonPathData: `https://${url}/SWDataservice/interface/v1/api?interfaceId=getTyphoonPathData`,
  getTyphoonForData: `https://${url}/SWDataservice/interface/v1/api?interfaceId=getTyphoonForData`,
  getHisTyphoonData: `https://${url}/SWDataservice/interface/v1/api?interfaceId=getHisTyphoonData`,
  getTypthonnTrack: `https://${url}/SWDataservice/interface/v1/api?interfaceId=getTypthonnTrack`, //低压接口
  getFishLineInfo: `https://${url}/SWDataservice/interface/v1/api?interfaceId=getFishLineInfo`, //科考航线
  updateFishLine: `https://${url}/SWDataservice/interface/v1/api?interfaceId=updateFishLine`, //更新科考航线
  insertLineDetail: `https://${url}/SWDataservice/interface/v1/api?interfaceId=insertLineDetail`, //插入航线点
  deleteFishLine: `https://${url}/SWDataservice/interface/v1/api?interfaceId=deleteFishLine`, //删除航线点
  getLastTypthoonForData: `https://${url}/SWDataservice/interface/v1/api?interfaceId=getLastTypthoonForData`,//获取台风上某个路径点的台风预报路径接口
  getWarninfo: `https://${url}/SWDataservice/interface/v1/api?interfaceId=getWarninfo&dataType=json`,//获取预警信号数据
  getTypthoonDefence: `https://${url}/SWDataservice/interface/v1/api?interfaceId=getTypthoonDefence`,//获取防御指南数据
  deleteByDefense: `https://${url}/SWDataservice/interface/v1/api?interfaceId=deleteByDefense`,//删除防御指南数据
  attachment: `https://${url}/SWDataservice/interface/attachment?`,//上传防御指南文件
  getTypthoonZdybData: `https://${url}/SWDataservice/interface/v1/api?interfaceId=getTypthoonZdybData`,//获取中大台风预报源数据
  insertTyphoonListZdyb: `https://${url}/SWDataservice/typhoon/insertTyphoonListZdyb`,//插入中大台风预报源数据
  updateTZDyb: `https://${url}/SWDataservice/typhoon/updateTyphoonListZdyb`,//更新中大台风预报源数据
  deleteTyphoonListZdyb: `https://${url}/SWDataservice/interface/v1/api?interfaceId=deleteTyphoonListZdyb`,//更新中大台风预报源数据
  userLogin: `https://${url}/SWDataservice/userLogin`,//登陆
  getTyphoonWC: `https://${url}/SWDataservice/interface/v1/api?interfaceId=`,
  getHisForTyphoon: `https://${url}/SWDataservice/interface/v1/api?interfaceId=getHisForTyphoon`,
  getTyhphoonAllLine: `https://${url}/SWDataservice/interface/v1/api?interfaceId=getTyhphoonAllLine`,//获取航线列表
  host: `https://${url}/SWDataservice/interface/v1/api?interfaceId=`,
  getNHGridData: `https://${url}/SWDataservice/typhoon/getNHGridData`,
  getAirGridDataByLonLat: `https://www.moodsmap.com//SWDataservice/typhoon/getAirGridDataByLonLat`
}
export default {
    install(Vue) {
      Vue.prototype.$ipConfig = ipConfig;
    }
}



//////////////////
// WEBPACK FOOTER
// ./ipConfig.js
// module id = yV5c
// module chunks = 2 3